export default __webpack_public_path__ + "static/media/hippopotamus.9fc7d5d9.webp";